import React, {useState} from "react";
import {Button, Columns, Form, Heading, Modal, Section} from "react-bulma-components";
import axios from "axios";
import {NotificationManager} from "react-notifications";
import TrackingOptionsPicker from "../../Settings/TrackingCategory/TrackingOptionsPicker";


export default function CreateInvoiceModal({autofill, open, setOpen, endpoint, trackingOptions, trackingOptionObjects}){
    const [invoice, setInvoice] = useState(autofill ?? {});

    const getVat = (invoice) => {
        return (invoice.amount * 0.2).toFixed(2);
    };

    const getTotal = (invoice) => {
        return ((invoice.amount * 1.2) + parseFloat(invoice.no_vat_amount ?? 0)).toFixed(2);
    };

    const onChange = e => {
        let newInvoice = {...invoice, [e.target.name] : e.target.value};
        setInvoice(newInvoice);
    }

    const onTrackingOptionChange = e => {
        const toUpdate = {
            target: {
                name: "tracking_option",
                value: trackingOptionObjects[e.target.value]
            }
        }
        onChange(toUpdate);
    }

    const onSave = (data) => {
        const conf = {
            url: endpoint+"invoices",
            method: "post",
            data: data
        }
        axios(conf).then((res) => {
            NotificationManager.success("Invoice Created Successfully")
            setOpen(false);
        }).catch(err => {
            NotificationManager.error("There was an error creating the invoice")
        })
    }

    return (
        <Modal
            show={open}
            onClose={() => {
                setOpen(false);
            }}
            closeOnBlur
        >
            <Modal.Content
                className={"wider-modal"}
            >
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column>
                            <Heading>Create Sale Invoice</Heading>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Form.Label>Customer</Form.Label>
                            <Form.Input
                                name={"customer"}
                                type={"text"}
                                disabled={true}
                                value={invoice.customer ? invoice.customer.display_name : ""}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Description</Form.Label>
                            <Form.Textarea
                                name={"description"}
                                onChange={onChange}
                                value={invoice.description}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Invoice Date</Form.Label>
                            <Form.Input
                                value={invoice.invoice_date}
                                name={"invoice_date"}
                                type={"date"}
                                onChange={onChange}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Invoice Number</Form.Label>
                            <Form.Input
                                value={invoice.invoice_number}
                                name={"invoice_number"}
                                type={"text"}
                                onChange={onChange}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <TrackingOptionsPicker
                                blank={true}
                                inlineEdit={false}
                                value={invoice.tracking_option}
                                options={trackingOptions}
                                onChange={onTrackingOptionChange}
                                editable={true}
                                label={"Tracking Option"}
                                name={"tracking_option"}
                            />
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Form.Label>Vatable Amount</Form.Label>
                            <Form.Input
                                type={"number"}
                                name={"amount"}
                                value={invoice.amount}
                                onChange={onChange}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Non Vatable Amount</Form.Label>
                            <Form.Input
                                type={"number"}
                                name={"no_vat_amount"}
                                value={invoice.no_vat_amount}
                                onChange={onChange}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>VAT</Form.Label>
                            <Form.Input
                                value={getVat(invoice)}
                                name={"vat"}
                                disabled={true}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Total Amount</Form.Label>
                            <Form.Input
                                value={getTotal(invoice)}
                                name={"total"}
                                disabled={true}
                            />
                        </Columns.Column>
                        <Columns.Column></Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Button
                                color={"success"}
                                fullwidth
                                onClick={() => {onSave(invoice)}}
                            >
                              Save
                            </Button>
                        </Columns.Column>
                        <Columns.Column>
                            <Button
                                color={"info"}
                                fullwidth
                                onClick={() => {
                                    setInvoice({});
                                    setOpen(false);
                                }}
                            >
                                Cancel
                            </Button>
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )


}